<template>
    <div class="text_box">
      {{text}}
    </div>
</template>
<script>
export default {
    props: ['text']
}
</script>
<style scoped>
/** 新增文本box */
.text_box{
  width: 670px;
  margin: 20px auto;
  border-radius: 5px;
  overflow: hidden;
  font-size: 30px;
  padding: 15px;
  text-align: left;
  text-indent: 55px;
  background-color: #fff;
  box-shadow: 0 0 10px 2px #ddd;
  color: rgba(46, 148, 229, 1);
  background-color: rgba(46, 148, 229, .1);
  color:#2c3e50;
}
</style>